'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _asyncGeneratorDelegate = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var importer = require('ipfs-unixfs-importer');

var normaliseAddInput = require('ipfs-core-utils/src/files/normalise-input');

var _require = require('./utils'),
    parseChunkerString = _require.parseChunkerString;

var pipe = require('it-pipe');

var _require2 = require('../../utils'),
    withTimeoutOption = _require2.withTimeoutOption;

module.exports = function (_ref4) {
  var block = _ref4.block,
      gcLock = _ref4.gcLock,
      preload = _ref4.preload,
      pin = _ref4.pin,
      constructorOptions = _ref4.options;
  var isShardingEnabled = constructorOptions.EXPERIMENTAL && constructorOptions.EXPERIMENTAL.sharding;
  return withTimeoutOption( /*#__PURE__*/function () {
    var _add = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source, options) {
      var opts, total, prog, iterator, releaseLock;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = options || {};
              opts = _objectSpread(_objectSpread({
                shardSplitThreshold: isShardingEnabled ? 1000 : Infinity
              }, options), {}, {
                strategy: 'balanced'
              }, parseChunkerString(options.chunker)); // CID v0 is for multihashes encoded with sha2-256

              if (opts.hashAlg && opts.hashAlg !== 'sha2-256' && opts.cidVersion !== 1) {
                opts.cidVersion = 1;
              }

              if (opts.trickle) {
                opts.strategy = 'trickle';
              }

              delete opts.trickle;

              if (opts.progress) {
                total = 0;
                prog = opts.progress;

                opts.progress = function (bytes) {
                  total += bytes;
                  prog(total);
                };
              }

              iterator = pipe(normaliseAddInput(source), function (source) {
                return importer(source, block, _objectSpread(_objectSpread({}, opts), {}, {
                  pin: false
                }));
              }, transformFile(opts), preloadFile(preload, opts), pinFile(pin, opts));
              _context.next = 9;
              return _awaitAsyncGenerator(gcLock.readLock());

            case 9:
              releaseLock = _context.sent;
              _context.prev = 10;
              return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(iterator), _awaitAsyncGenerator), "t0", 12);

            case 12:
              _context.prev = 12;
              releaseLock();
              return _context.finish(12);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[10,, 12, 15]]);
    }));

    function add(_x, _x2) {
      return _add.apply(this, arguments);
    }

    return add;
  }());
};

function transformFile(opts) {
  return /*#__PURE__*/function () {
    var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(source) {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, file, cid, path;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context2.prev = 2;
              _iterator = _asyncIterator(source);

            case 4:
              _context2.next = 6;
              return _awaitAsyncGenerator(_iterator.next());

            case 6:
              _step = _context2.sent;
              _iteratorNormalCompletion = _step.done;
              _context2.next = 10;
              return _awaitAsyncGenerator(_step.value);

            case 10:
              _value = _context2.sent;

              if (_iteratorNormalCompletion) {
                _context2.next = 22;
                break;
              }

              file = _value;
              cid = file.cid;

              if (opts.cidVersion === 1) {
                cid = cid.toV1();
              }

              path = file.path ? file.path : cid.toString();

              if (opts.wrapWithDirectory && !file.path) {
                path = '';
              }

              _context2.next = 19;
              return {
                path: path,
                cid: cid,
                size: file.size,
                mode: file.unixfs && file.unixfs.mode,
                mtime: file.unixfs && file.unixfs.mtime
              };

            case 19:
              _iteratorNormalCompletion = true;
              _context2.next = 4;
              break;

            case 22:
              _context2.next = 28;
              break;

            case 24:
              _context2.prev = 24;
              _context2.t0 = _context2["catch"](2);
              _didIteratorError = true;
              _iteratorError = _context2.t0;

            case 28:
              _context2.prev = 28;
              _context2.prev = 29;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context2.next = 33;
                break;
              }

              _context2.next = 33;
              return _awaitAsyncGenerator(_iterator.return());

            case 33:
              _context2.prev = 33;

              if (!_didIteratorError) {
                _context2.next = 36;
                break;
              }

              throw _iteratorError;

            case 36:
              return _context2.finish(33);

            case 37:
              return _context2.finish(28);

            case 38:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 24, 28, 38], [29,, 33, 37]]);
    }));

    return function (_x3) {
      return _ref.apply(this, arguments);
    };
  }();
}

function preloadFile(preload, opts) {
  return /*#__PURE__*/function () {
    var _ref2 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(source) {
      var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, file, isRootFile, shouldPreload;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _context3.prev = 2;
              _iterator2 = _asyncIterator(source);

            case 4:
              _context3.next = 6;
              return _awaitAsyncGenerator(_iterator2.next());

            case 6:
              _step2 = _context3.sent;
              _iteratorNormalCompletion2 = _step2.done;
              _context3.next = 10;
              return _awaitAsyncGenerator(_step2.value);

            case 10:
              _value2 = _context3.sent;

              if (_iteratorNormalCompletion2) {
                _context3.next = 21;
                break;
              }

              file = _value2;
              isRootFile = !file.path || opts.wrapWithDirectory ? file.path === '' : !file.path.includes('/');
              shouldPreload = isRootFile && !opts.onlyHash && opts.preload !== false;

              if (shouldPreload) {
                preload(file.cid);
              }

              _context3.next = 18;
              return file;

            case 18:
              _iteratorNormalCompletion2 = true;
              _context3.next = 4;
              break;

            case 21:
              _context3.next = 27;
              break;

            case 23:
              _context3.prev = 23;
              _context3.t0 = _context3["catch"](2);
              _didIteratorError2 = true;
              _iteratorError2 = _context3.t0;

            case 27:
              _context3.prev = 27;
              _context3.prev = 28;

              if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                _context3.next = 32;
                break;
              }

              _context3.next = 32;
              return _awaitAsyncGenerator(_iterator2.return());

            case 32:
              _context3.prev = 32;

              if (!_didIteratorError2) {
                _context3.next = 35;
                break;
              }

              throw _iteratorError2;

            case 35:
              return _context3.finish(32);

            case 36:
              return _context3.finish(27);

            case 37:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[2, 23, 27, 37], [28,, 32, 36]]);
    }));

    return function (_x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function pinFile(pin, opts) {
  return /*#__PURE__*/function () {
    var _ref3 = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(source) {
      var _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _value3, file, isRootDir, shouldPin;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _iteratorNormalCompletion3 = true;
              _didIteratorError3 = false;
              _context4.prev = 2;
              _iterator3 = _asyncIterator(source);

            case 4:
              _context4.next = 6;
              return _awaitAsyncGenerator(_iterator3.next());

            case 6:
              _step3 = _context4.sent;
              _iteratorNormalCompletion3 = _step3.done;
              _context4.next = 10;
              return _awaitAsyncGenerator(_step3.value);

            case 10:
              _value3 = _context4.sent;

              if (_iteratorNormalCompletion3) {
                _context4.next = 23;
                break;
              }

              file = _value3;
              // Pin a file if it is the root dir of a recursive add or the single file
              // of a direct add.
              isRootDir = !file.path.includes('/');
              shouldPin = (opts.pin == null ? true : opts.pin) && isRootDir && !opts.onlyHash;

              if (!shouldPin) {
                _context4.next = 18;
                break;
              }

              _context4.next = 18;
              return _awaitAsyncGenerator(pin.add(file.cid, {
                preload: false,
                lock: false
              }));

            case 18:
              _context4.next = 20;
              return file;

            case 20:
              _iteratorNormalCompletion3 = true;
              _context4.next = 4;
              break;

            case 23:
              _context4.next = 29;
              break;

            case 25:
              _context4.prev = 25;
              _context4.t0 = _context4["catch"](2);
              _didIteratorError3 = true;
              _iteratorError3 = _context4.t0;

            case 29:
              _context4.prev = 29;
              _context4.prev = 30;

              if (!(!_iteratorNormalCompletion3 && _iterator3.return != null)) {
                _context4.next = 34;
                break;
              }

              _context4.next = 34;
              return _awaitAsyncGenerator(_iterator3.return());

            case 34:
              _context4.prev = 34;

              if (!_didIteratorError3) {
                _context4.next = 37;
                break;
              }

              throw _iteratorError3;

            case 37:
              return _context4.finish(34);

            case 38:
              return _context4.finish(29);

            case 39:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[2, 25, 29, 39], [30,, 34, 38]]);
    }));

    return function (_x5) {
      return _ref3.apply(this, arguments);
    };
  }();
}